import React, { useContext } from 'react';
import MetaTags from "react-meta-tags";
import { AuthContext } from "../common/Auth"

export default function MetaTag() {

    const { metaData, tabName } = useContext(AuthContext);

    return (
        <>
            <MetaTags>
                <title>
                    {tabName ? tabName : "Antera Software Aether Web Stores"}
                </title>
                <meta
                    name="description"
                    content={metaData.description ? metaData.description : ""}
                />
            </MetaTags>
        </>
    );
}